<template>

  <div>
    <div class="container editor">

      <p class="mt-10">
        Na WDC prezamos por uma cultura em que todos os envolvidos se sintam respeitados e admirem a empresa e seus colegas de trabalho, e um bom ambiente faz parte disso! É por isso que
        oferecemos alguns mimos a todos que trabalham na WDC.
      </p>
        <div  class="cards grid grid-cols-2 lg:grid-cols-4 md:grid-cols-3 gap-10  my-10 py-10">

            <div  class=" max-w-sm rounded overflow-hidden shadow-lg bg-white">
                <img class="w-full" src="@/assets/images/novaintegracao/diferencial1.png" alt="Sunset in the mountains" />
                <div class="px-6 py-4">
                <div class="font-bold text-base md:text-xl text-center mb-2 azulwdc">No Dress Code, aqui você pode ser você mesmo</div>
                </div>
            </div>

            <vs-popup class="holamundo" title="No Dress Code, aqui você pode ser você mesmo" :active.sync="popupActive">

                <iframe width="560" height="315" src="https://www.youtube.com/embed/Bbb7TZ3JkmA" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

            </vs-popup>



             <div class=" max-w-sm rounded overflow-hidden shadow-lg bg-white">
                <img class="w-full" src="@/assets/images/novaintegracao/diferencial2.png" alt="Sunset in the mountains" />
                <div class="px-6 py-4">
                <div class="font-bold text-base md:text-xl text-center mb-2 azulwdc">Spotify gratuito disponível para todos;</div>
                </div>
            </div>

             <div class=" max-w-sm rounded overflow-hidden shadow-lg bg-white">
                <img class="w-full" src="@/assets/images/novaintegracao/diferencial3.png" alt="Sunset in the mountains" />
                <div class="px-6 py-4">
                <div class="font-bold text-base md:text-xl text-center mb-2 azulwdc">Ambiente
                  agradável
                  e amigável;</div>
                </div>
            </div>

             <div class=" max-w-sm rounded overflow-hidden shadow-lg bg-white">
                <img class="w-full" src="@/assets/images/novaintegracao/diferencial3.png" alt="Sunset in the mountains" />
                <div class="px-6 py-4">
                <div class="font-bold text-base md:text-xl text-center mb-2 azulwdc">Bootcamps,
                  palestras
                  agragadoras;</div>
                </div>
            </div>

             <div class=" max-w-sm rounded overflow-hidden shadow-lg bg-white">
                <img class="w-full" src="@/assets/images/novaintegracao/diferencial1.png" alt="Sunset in the mountains" />
                <div class="px-6 py-4">
                <div class="font-bold text-base md:text-xl text-center mb-2 azulwdc">Lanchinhos e
                  frigobar;
                </div>
                </div>
            </div>

             <div class=" max-w-sm rounded overflow-hidden shadow-lg bg-white">
                <img class="w-full" src="@/assets/images/novaintegracao/diferencial2.png" alt="Sunset in the mountains" />
                <div class="px-6 py-4">
                <div class="font-bold text-base md:text-xl text-center mb-2 azulwdc">Happy Hour toda última sexta-feira do mês;</div>
                </div>
            </div>

             <div class=" max-w-sm rounded overflow-hidden shadow-lg bg-white">
                <img class="w-full" src="@/assets/images/novaintegracao/diferencial2.png" alt="Sunset in the mountains" />
                <div class="px-6 py-4">
                <div class="font-bold text-base md:text-xl text-center mb-2 azulwdc">Remuneração, reconhemcinento e recompensas;

                </div>
                </div>
            </div>

             <div class=" max-w-sm rounded overflow-hidden shadow-lg bg-white">
                <img class="w-full" src="@/assets/images/novaintegracao/diferencial3.png" alt="Sunset in the mountains" />
                <div class="px-6 py-4">
                <div class="font-bold text-base md:text-xl text-center mb-2 azulwdc">Plano de saúde e odontológico;

                </div>
                </div>
            </div>

             <div class=" max-w-sm rounded overflow-hidden shadow-lg bg-white">
                <img class="w-full" src="@/assets/images/novaintegracao/diferencial1.png" alt="Sunset in the mountains" />
                <div class="px-6 py-4">
                <div class="font-bold text-base md:text-xl text-center mb-2 azulwdc">Cursos e
                  qualificações</div>
                </div>
            </div>



        </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "Diferenciais",
  props: [],
  created() {},
  data() {
    return {
      pronome: "a",
      animation_path: [],
      width: window.innerWidth,
      popupActive: false,
    };
  },
  methods: {
    next(step) {
      this.$store.dispatch("integracao/setStep", step).then(() => {
        this.$router.push({
          name: "integracao-" + this.$store.state.integracao.page,
        });
      });
    },
  },
  watch: {
    windowWidth() {
      this.width = window.innerWidth;
    },
  },
  computed: {
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
};
</script>

<style scoped>
</style>
